import { QuizSetContributorResRole } from '@/api/gen/_model/quizSetContributorResRole';
import type { QuizSetDetailsRes } from '@/api/gen/_model/quizSetDetailsRes';
import { type CheckMyQuizStatus } from '@/hooks/useCheckMyQuiz';

import { type HeroCardData, type HeroCardOriginalAuthor } from '../types';

/**
 * 출처 목록. 서버 `contributors` 가 본인 제외·중복 제거·정렬까지 끝낸 값이라 옮기기만 한다.
 * 생성 타입은 필수지만 구 서버(배포 시차)는 안 내리므로 `?? []` 를 지우면 안 된다.
 * 없으면 기존 `originAuthor*` 한 명으로 떨어진다.
 */
const toOriginalAuthors = (
  data: QuizSetDetailsRes,
): HeroCardOriginalAuthor[] => {
  const contributors = data.contributors ?? [];

  if (contributors.length > 0) {
    return contributors.map(contributor => ({
      name: contributor.name,
      id: contributor.id,
      isAmbassador: contributor.isAmbassador,
      role: contributor.role,
    }));
  }

  if (!data.originAuthorName || !data.originAuthorId) return [];

  return [
    {
      name: data.originAuthorName,
      id: data.originAuthorId,
      isAmbassador: data.isOriginAuthorAmbassador || false,
      role: QuizSetContributorResRole.QUIZSET_ORIGIN,
    },
  ];
};

export const useHeroCardData = (
  data: QuizSetDetailsRes,
  meStatus: CheckMyQuizStatus,
): HeroCardData => {
  return {
    image: {
      url: data.templateImageUrl || '',
      planType: data.templatePlanType,
      type: data.templateType,
    },
    category: data.categoryTreeData,
    title: data.title,
    author: data.authorUsername
      ? {
          username: data.authorUsername,
          id: data.authorId,
          isOfficial: data.isOfficial || false,
          avatarData: data.authorAvatarData,
        }
      : undefined,
    metadata: {
      createdAt: data.createdAt,
      playCount: data.playCount || 0,
      copyCount: data.copyCount || 0,
    },
    originalAuthors: toOriginalAuthors(data),
    variant: meStatus === 'isMe' ? 'my' : 'default',
  };
};
